import axios from "axios";
import { ResponseAPIModel } from "../../../../setup/models/ResponseAPIModel";
import { WebUserModel, Roles, FindUserRequestModel } from "../models";

const API_URL = process.env.REACT_APP_API_URL || '/api'
export const POST_CREATE_USER = `${API_URL}/User/create-user`;
export const POST_UPDATE_EMAIL = `${API_URL}/User/update-email`;
export const POST_UPDATE_PHONENUMBER = `${API_URL}/User/update-phonenumber`;
export const POST_ROLES = `${API_URL}/User/update-roles`;
export const GET_ROLES = `${API_URL}/User/get-roles`;
export const POST_NAME_SURNAME = `${API_URL}/User/update-name-surname`;
export const POST_USERNAME = `${API_URL}/User/update-username`;
export const POST_PASSWORD_WITH_EMAIL = `${API_URL}/User/update-password-with-email`;
export const GET_USER = `${API_URL}/User/get-user`;
export const POST_FIND_USER = `${API_URL}/User/find-user`;

export function getUser(userId: number) {
  return axios.post<ResponseAPIModel<WebUserModel>>(GET_USER, { id: userId });
}

export function getRoles() {
  return axios.get<ResponseAPIModel<Roles[]>>(GET_ROLES);
}

export function createUser(user: WebUserModel) {
  return axios.post<ResponseAPIModel<WebUserModel>>(POST_CREATE_USER, user);
}

export function getFindUser(user: FindUserRequestModel) {
  return axios.post<ResponseAPIModel<WebUserModel[]>>(POST_FIND_USER, user);
}

export function updateNameSurname(userId: number, name: string, surname: string) {
  return axios.post<ResponseAPIModel<Boolean>>(POST_NAME_SURNAME, { id: userId, name, surname });
}

export function updateUsername(userId: number, username: string) {
  return axios.post<ResponseAPIModel<Boolean>>(POST_USERNAME, { id: userId, username });
}

export function updatePhone(userId: number, phoneNumber: string) {
  return axios.post<ResponseAPIModel<Boolean>>(POST_UPDATE_PHONENUMBER, { id: userId, phoneNumber });
}

export function updateEmail(userId: number, email: string) {
  return axios.post<ResponseAPIModel<Boolean>>(POST_UPDATE_EMAIL, { id: userId, email });
}

export function updateUserRoles(userId: number, roleIds: Array<number>) {
  return axios.post<ResponseAPIModel<Boolean>>(POST_ROLES, { id: userId, roleIds });
}

export function resetPasswordRequest(userId: number, email: string) {
  return axios.post<ResponseAPIModel<Boolean>>(POST_PASSWORD_WITH_EMAIL, { id: userId, email });
}
